/* eslint-disable */
import { useEffect, useState } from 'react';
import TableRowProduct from './tableRowproduct';
function TableComponent(props) {
    const {columns, data, handleRemove = () => {}, setNewList = () => {}, isDisabled = false} = props;
    const handleUpdate = (id, key, value, inputType) => {
        const stringValue = String(value);
      
        if ((key === 'min' || key === 'max') && stringValue.includes('.')) {
          if (inputType === 'number') {
            const numValue = stringValue.split('.')[0];
            const formattedValue = parseInt(numValue, 10);
            setNewList((prevList) =>
              prevList.map((item) =>
                item.id === id ? { ...item, [key]: formattedValue } : item
              )
            );
          } else if (inputType === 'decimal') {
            const decimalRegex = /^\d+(\.\d{0,3})?$/;
            if (decimalRegex.test(stringValue)) {
              const formattedValue = parseFloat(stringValue);
              setNewList((prevList) =>
                prevList.map((item) =>
                  item.id === id ? { ...item, [key]: formattedValue } : item
                )
              );
            }
          }
        } else {
          setNewList((prevList) =>
            prevList.map((item) =>
              item.id === id ? { ...item, [key]: value } : item
            )
          );
        }
      };
      
    return (
        <div>
            <table>
                <thead>
                    <tr>
                        {columns.map((coloumn) => (
                            <th 
                                key={coloumn.name}
                                style={{
                                    width: coloumn?.width ? coloumn.width : ''
                                }}
                            >
                                {coloumn?.icon && coloumn?.icon}
                                {coloumn.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item) => (
                        <TableRowProduct 
                            columns={columns}
                            rowData={item}
                            handleRemove={handleRemove}
                            handleUpdate={handleUpdate}
                            isDisabled={isDisabled}
                        />
                    ))}
                </tbody>
            </table>

        </div>
    );
}
export default TableComponent;  
